import type { Event as DatasetEvent } from '@store/unifiedDataStore';

/** GET /api/events returns jsonb as object from node-pg; HuniDB may store string. */
export function parseDatasetEventTags(
  tags: string | Record<string, unknown> | null | undefined
): Record<string, unknown> | null {
  if (tags == null) {return null;}
  if (typeof tags === 'object' && !Array.isArray(tags)) {
    return tags as Record<string, unknown>;
  }
  const s = String(tags).trim();
  if (!s) {return null;}
  try {
    const o = JSON.parse(s) as unknown;
    return o != null && typeof o === 'object' && !Array.isArray(o) ? (o as Record<string, unknown>) : null;
  } catch {
    return null;
  }
}

/** NOTE text from an already-parsed tags object (avoids a second parse when combined with thumbs). */
export function noteTextFromParsedTags(t: Record<string, unknown> | null): string {
  if (!t) {return '';}
  const n = t.NOTE ?? t.note;
  if (typeof n === 'string') {return n;}
  if (n != null && typeof n !== 'object') {return String(n);}
  return '';
}

export function noteTextFromDatasetEvent(ev: Pick<DatasetEvent, 'tags'>): string {
  return noteTextFromParsedTags(parseDatasetEventTags(ev.tags));
}

export function tagThumbsFromTags(tags: Record<string, unknown> | null | undefined): boolean | null {
  if (tags == null || typeof tags !== 'object') {return null;}
  const v = tags.thumbsup;
  if (v === true || v === 'true') {return true;}
  if (v === false || v === 'false') {return false;}
  return null;
}

export function datasetThumbsState(ev: Pick<DatasetEvent, 'tags'>): boolean | null {
  return tagThumbsFromTags(parseDatasetEventTags(ev.tags));
}

/** Maneuver table row: thumbs from flat `thumbsup` (maneuvers-table-data) or nested `tags`. */
export function datasetThumbsStateFromRow(
  row: Record<string, unknown> | null | undefined
): boolean | null {
  if (!row || typeof row !== 'object') {return null;}
  if (row.thumbsup !== undefined && row.thumbsup !== null) {
    const direct = tagThumbsFromTags({ thumbsup: row.thumbsup });
    if (direct !== null) {return direct;}
  }
  if (row.tags !== undefined) {
    return datasetThumbsState({ tags: row.tags as DatasetEvent['tags'] });
  }
  return null;
}
